export default "__VITE_ASSET__BRW0rKKY__"